export async function idml2docbook(file: File, options: Record<string, string | boolean>) {
    if (!file) return;
    
    const formData = new FormData();
    formData.append("file", file);

    Object.keys(options).forEach(key => {
        if (typeof options[key] === "boolean") {
            options[key]
            ? formData.append(key, "true" )
            : formData.append(key, "false" );
        } else formData.append(key, options[key] );
    })
    
    const url = (import.meta.env.MODE === "development")
        ? "/api/idml2docbook"
        : `${import.meta.env.VITE_IDML2DOCBOOK_PROD_SERVER}/convert`

    try {
        const response = await fetch(url, {
            method: "POST",
            body: formData
        });
        
        if (!response.ok) {
            throw new Error(`Server error: ${response.status}`);
        }
        
        const result = await response.json();
        return result;
        
    } catch (error) {
        console.error("Conversion failed: Sent request to:", url, "\n", error);
    }
}